export class Typewriter {
    constructor(container, options) {
      this.container = container
      this.speed = options.speed || 50
      this.queue = []
      this.timer = null
      this.isConsuming = false
      this.onComplete = options.onComplete || (() => {})
    }
  
    add(text) {
      this.queue.push(...text.split(''))
      this.consume()
      console.log(this.queue);
      
    }
  
    consume() {
      if (this.queue.length === 0 || this.isConsuming) return
      
      this.isConsuming = true
      const char = this.queue.shift()
      
      this.container.innerHTML += char
      this.timer = setTimeout(() => {
        this.isConsuming = false
        this.consume()
      }, this.speed)
    }
  }